import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 5.5C1 5.22386 1.22386 5 1.5 5H10.5C10.7761 5 11 5.22386 11 5.5C11 5.77614 10.7761 6 10.5 6H1.5C1.22386 6 1 5.77614 1 5.5Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 2.5C1 2.22386 1.22386 2 1.5 2H10.5C10.7761 2 11 2.22386 11 2.5C11 2.77614 10.7761 3 10.5 3H1.5C1.22386 3 1 2.77614 1 2.5Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4 8.5C4 8.22386 4.22386 8 4.5 8H10.5C10.7761 8 11 8.22386 11 8.5C11 8.77614 10.7761 9 10.5 9H4.5C4.22386 9 4 8.77614 4 8.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 7.66667C1 7.29848 1.29848 7 1.66667 7H13.6667C14.0349 7 14.3333 7.29848 14.3333 7.66667C14.3333 8.03486 14.0349 8.33333 13.6667 8.33333H1.66667C1.29848 8.33333 1 8.03486 1 7.66667Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 3.66667C1 3.29848 1.29848 3 1.66667 3H13.6667C14.0349 3 14.3333 3.29848 14.3333 3.66667C14.3333 4.03486 14.0349 4.33333 13.6667 4.33333H1.66667C1.29848 4.33333 1 4.03486 1 3.66667Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5 11.6667C5 11.2985 5.29848 11 5.66667 11H13.6667C14.0349 11 14.3333 11.2985 14.3333 11.6667C14.3333 12.0349 14.0349 12.3333 13.6667 12.3333H5.66667C5.29848 12.3333 5 12.0349 5 11.6667Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 9.83333C2 9.3731 2.3731 9 2.83333 9H17.8333C18.2936 9 18.6667 9.3731 18.6667 9.83333C18.6667 10.2936 18.2936 10.6667 17.8333 10.6667H2.83333C2.3731 10.6667 2 10.2936 2 9.83333Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2 4.83333C2 4.3731 2.3731 4 2.83333 4H17.8333C18.2936 4 18.6667 4.3731 18.6667 4.83333C18.6667 5.29357 18.2936 5.66667 17.8333 5.66667H2.83333C2.3731 5.66667 2 5.29357 2 4.83333Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M7 14.8333C7 14.3731 7.3731 14 7.83333 14H17.8333C18.2936 14 18.6667 14.3731 18.6667 14.8333C18.6667 15.2936 18.2936 15.6667 17.8333 15.6667H7.83333C7.3731 15.6667 7 15.2936 7 14.8333Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 3C10.7761 3 11 3.22386 11 3.5C11 3.77614 10.7761 4 10.5 4H1.5C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3H10.5Z" fill="currentColor" />
      <path d="M10.5 6C10.7761 6 11 6.22386 11 6.5C11 6.77614 10.7761 7 10.5 7H1.5C1.22386 7 1 6.77614 1 6.5C1 6.22386 1.22386 6 1.5 6H10.5Z" fill="currentColor" />
      <path d="M10.5 9L10.5513 9.00244C10.8033 9.02811 11 9.24116 11 9.5C11 9.75884 10.8033 9.97189 10.5513 9.99756L10.5 10H4.5C4.22386 10 4 9.77614 4 9.5C4 9.22386 4.22386 9 4.5 9H10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.3334 3C14.7015 3 15 3.29848 15 3.66667C15 4.03486 14.7015 4.33333 14.3334 4.33333H2.33335C1.96516 4.33333 1.66669 4.03486 1.66669 3.66667C1.66669 3.29848 1.96516 3 2.33335 3H14.3334Z" fill="currentColor" />
      <path d="M14.3334 7.33301C14.7015 7.33301 15 7.63148 15 7.99967C15 8.36786 14.7015 8.66634 14.3334 8.66634H2.33335C1.96516 8.66634 1.66669 8.36786 1.66669 7.99967C1.66669 7.63148 1.96516 7.33301 2.33335 7.33301H14.3334Z" fill="currentColor" />
      <path d="M14.3334 11.667L14.4017 11.6702C14.7378 11.7045 15 11.9885 15 12.3337C15 12.6788 14.7378 12.9628 14.4017 12.9971L14.3334 13.0003H6.33335C5.96516 13.0003 5.66669 12.7018 5.66669 12.3337C5.66669 11.9655 5.96516 11.667 6.33335 11.667H14.3334Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.1666 4C17.6269 4 18 4.3731 18 4.83333C18 5.29357 17.6269 5.66667 17.1666 5.66667H2.16665C1.70641 5.66667 1.33331 5.29357 1.33331 4.83333C1.33331 4.3731 1.70641 4 2.16665 4H17.1666Z" fill="currentColor" />
      <path d="M17.1666 8.66699C17.6269 8.66699 18 9.04009 18 9.50033C18 9.96056 17.6269 10.3337 17.1666 10.3337H2.16665C1.70641 10.3337 1.33331 9.96056 1.33331 9.50033C1.33331 9.04009 1.70641 8.66699 2.16665 8.66699H17.1666Z" fill="currentColor" />
      <path d="M17.1666 13.333L17.2521 13.3371C17.6722 13.3799 18 13.7349 18 14.1663C18 14.5977 17.6722 14.9528 17.2521 14.9956L17.1666 14.9997H7.16665C6.70641 14.9997 6.33331 14.6266 6.33331 14.1663C6.33331 13.7061 6.70641 13.333 7.16665 13.333H17.1666Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconMenu04: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"menu-04"} {...props} />
);
